import { render, staticRenderFns } from "./advertmaterial.vue?vue&type=template&id=1fd872b6&"
import script from "./advertmaterial.vue?vue&type=script&lang=js&"
export * from "./advertmaterial.vue?vue&type=script&lang=js&"
import style0 from "./advertmaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports